/* eslint-disable @nx/enforce-module-boundaries */
'use-client';
import { isMobile } from 'react-device-detect';
import { ProfileLayout } from 'v4/snippets/profile/layout';
import { MyProfileVideos } from 'v4/snippets/profile/videos';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';

const Profile = () => {
  return (
    <AuthenticatedProviders>
      {/* <ProfileLayout active={isMobile?2:3}> */}
      <ProfileLayout active={3}>
        <MyProfileVideos />
      </ProfileLayout>
    </AuthenticatedProviders>
  );
};

export default Profile;
